var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullseye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.682,0 -23,10.318 -23,23c0,12.682 10.318,23 23,23c12.682,0 23,-10.318 23,-23c0,-4.597 -1.36036,-8.88052 -3.69336,-12.47852l-0.89258,0.89258l-0.58594,0.58594h-0.82812h-1.75781l-2.73242,2.73242c1.571,2.371 2.49023,5.21058 2.49023,8.26758c0,8.284 -6.716,15 -15,15c-8.284,0 -15,-6.716 -15,-15c0,-8.284 6.716,-15 15,-15c3.057,0 5.89658,0.91923 8.26758,2.49023l2.73242,-2.73242v-1.75781v-0.82812l0.58594,-0.58594l0.88867,-0.88867c-3.596,-2.334 -7.87761,-3.69727 -12.47461,-3.69727zM43,3l-5,5v2.58594l-13.70703,13.70703c-0.26124,0.25082 -0.36648,0.62327 -0.27512,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27512l13.70703,-13.70703h2.58594l5,-5h-4zM25,16c-4.962,0 -9,4.038 -9,9c0,4.962 4.038,9 9,9c4.962,0 9,-4.038 9,-9c0,-1.387 -0.32472,-2.69514 -0.88672,-3.86914l-5.99219,5.99023c-0.566,0.567 -1.32009,0.87891 -2.12109,0.87891c-0.801,0 -1.55509,-0.31191 -2.12109,-0.87891c-0.567,-0.566 -0.87891,-1.32009 -0.87891,-2.12109c0,-0.801 0.31191,-1.55509 0.87891,-2.12109l5.99219,-5.99219c-1.173,-0.565 -2.48409,-0.88672 -3.87109,-0.88672z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.b2c3fd218a3bded157653867635a6e26.svg";
export { ForwardRef as ReactComponent };